import React from 'react';
import Navigation from './components/Navigation';
import HomePage from './pages/HomePage';
import MelangePage from './pages/MelangePage';
import EpicePage from './pages/EpicePage';
import NotreHistoire from './pages/NotreHistoire';
import IdeesRecettes from './pages/IdeesRecettes';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import ScrollToTop from './components/ScrollToTop';
import Analytics from './components/Analytics';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Analytics />
        <div className="App">
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/notre-histoire" element={<NotreHistoire />} />
              <Route path="/melange/:melangeId" element={<MelangePage />} />
              <Route path="/epice/:epiceId/:melangeId" element={<EpicePage />} />
              <Route path="/idees-recettes" element={<IdeesRecettes />} />
            </Routes>
          </main>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
